import React, { useMemo } from 'react'
import styles from './PaymentsLogoWrapper.module.css'

const PaymentsLogoWrapper: React.FC = () => {
  const domain = window.location.hostname

  const payments = useMemo(() => {
    return (
      domain !== 'er-contributions.ru' &&
      domain !== 'www.er-contributions.ru' &&
      domain !== 'v2.er-contributions.ru'
    )
  }, [domain])

  return payments ? (
    <div
      className={`${styles.wrapper} flex flex-row flex-nowrap items-center justify-around px-4 py-3 mt-1`}
    >
      <div className={`${styles.img} flex-1`}>
        <img src="/img/mir-logo.svg" alt="mir" loading="lazy" />
      </div>
      <div className={`${styles.img} flex-1`}>
        <img src="/img/visa-logo.svg" alt="visa" loading="lazy" />
      </div>
      <div className={`${styles.img} flex-1`}>
        <img src="/img/master-logo.svg" alt="master" loading="lazy" />
      </div>
    </div>
  ) : null
}

export default PaymentsLogoWrapper
